<template>
    <div>
        <div>
            <h3 class="text-center">
                Select your health goals
            </h3>
            <p class="my-3">
                Please select up to 3 health goals to focus your advice and recommendations.
            </p>
        </div>
        <form @submit.prevent="saveAnswers" class="my-3">
            <h4 class="my-3">Wellbeing Goals</h4>
            <fieldset class="my-3">
                <div class="d-flex" v-for="goal in wellbeingGoals" :key="goal.id">
                    <div class="p-1">
                        <input v-model="patientAnswers.wellbeing_goals" :id="goal.id" :name="goal.id" :value="goal.id"
                            type="checkbox"
                            class="" />
                    </div>
                    <div class="mx-2 text-start">
                        <label :for="goal.id" class="cursor-pointer">
                            {{ goal.title }}
                        </label>
                        <p class="text-gray-500" v-if="goal.description">
                            {{ goal.description }}
                        </p>
                    </div>
                </div>
            </fieldset>
            <div v-if="errorMessage" class="alert alert-danger p-2 my-3">
                {{ errorMessage }}
            </div>
            <button class="ldna-btn my-3">Save</button>
        </form>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { saveQuestionnaireAnswers,  } from "@/services/health/health";
import { wellbeingGoals } from "@/static/content/health";

//import store from "@/store";

const router = useRouter();

const initialData = {
    exercise_days: null,
    exercise_hours: null,
    alcohol_units: null,
    cigarettes: {},
    pregnant: null,
    pregnancy_trimester: null,
    menstrual_cycle: null,
    wellbeing_goals: [],
    purpose: null,
    height: {
        value: null,
        unit: "cm",
    },
    weight: {
        value: null,
        unit: "kg",
    },
    blood_pressure: {
        systolic: null,
        diastolic: null,
    },
    past_conditions: [],
    allergies: [],
    past_supplements: [],
    past_surgeries: [],
    family_medical_conditions: [],
    symptoms_past_month: [],
    prescription_drugs: [],
    recreational_drugs: [],
    diet_style: [],
    personal_health: "",
};

const errorMessage = ref('');
const patientAnswers = ref(initialData);

const saveAnswers = async () => {
    errorMessage.value = '';
    if (patientAnswers.value.wellbeing_goals.length === 0) {
        errorMessage.value = "Please choose at least one health goal";
        return;
    }
    if (patientAnswers.value.wellbeing_goals.length > 3) {
        errorMessage.value = "Please select 3 or fewer health goals";
        return;
    }
    await saveQuestionnaireAnswers({
        answers: patientAnswers.value
    })
        .then(() => {
            router.push({ name: "activation-family-networks-opt-in" });
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>
